@if ($row(); as row) {
    @if ($selectSlot()) {
      <span class="select" (click)="$event.stopPropagation()">
        @if ($selectable()) {
          <wb-checkbox size="xsmall" [checked]="$selected()" [indeterminate]="$indeterminate()" (onToggle)="onSelectionToggle($event)" />
        }
      </span>
    }
    <div class="body">
      @if (isNested(row)) {
        <svg class="nested-connector" viewBox="0 0 28 44" preserveAspectRatio="none" aria-hidden="true" focusable="false">
          @if (isLastNestedSibling(row)) {
            <path d="M10 0 V9 Q10 22 20 22 H28" />
          } @else {
            <path d="M10 0 V44" />
            <path d="M10 9 Q10 22 20 22 H28" />
          }
        </svg>
      }
      @if (!isNested(row) && (reserveTreeGutter() || !presentationRow())) {
        <div class="gutter">
          @if (!presentationRow() && row.hasChildren) {
            <button type="button" class="chevron" tabindex="-1" [class.expanded]="$expanded()" [attr.aria-label]="$expanded() ? 'Collapse ' + row.name : 'Expand ' + row.name" [attr.aria-expanded]="$expanded()" (mousedown)="$event.preventDefault()" (click)="toggleExpanded($event, row)"><i class="fa-regular fa-chevron-right" aria-hidden="true"></i></button>
          }
        </div>
      } @else if (isNested(row) && !isSubtask(row) && row.hasChildren && !presentationRow()) {
        <div class="gutter">
          <button type="button" class="chevron" tabindex="-1" [class.expanded]="$expanded()" [attr.aria-label]="$expanded() ? 'Collapse ' + row.name : 'Expand ' + row.name" [attr.aria-expanded]="$expanded()" (mousedown)="$event.preventDefault()" (click)="toggleExpanded($event, row)"><i class="fa-regular fa-chevron-right" aria-hidden="true"></i></button>
        </div>
      }
      @if (!presentationRow() || presentationIcon() !== null) {
        <span class="type-glyph">
          @if (presentationRow() && presentationIcon(); as icon) {
            <i [class]="icon" aria-hidden="true"></i>
          } @else if (isLine(row)) {
            <i class="fa-solid fa-layer-group" aria-hidden="true"></i>
          } @else if (isSubtask(row)) {
            <span class="dot"></span>
          } @else {
            <i class="fa-regular fa-clipboard-check" aria-hidden="true"></i>
          }
        </span>
      }
      <div class="content">
        <span class="title">{{ row.name }}</span>
        @if (isLine(row) && row.workCategory?.name) {
          <w-badge class="category" [mode]="BadgeMode.Pill" [label]="row.workCategory.name" [dots]="row.workCategory.color ? [row.workCategory.color] : null" color="var(--local-outline-row-property-text)" backgroundColor="var(--local-outline-row-property-bg)" borderColor="var(--local-outline-row-property-border)" size="xs" />
        }
        @if (row.mandatory) {
          <span class="mandatory" aria-label="Mandatory">*</span>
        }
        @if ($showDescription() && row.description) {
          <span class="summary">{{ row.description }}</span>
        }
      </div>
      <span class="row-spacer"></span>
      <div class="trailing">
        @if (canAddChild(row)) {
          <div class="actions" (click)="$event.stopPropagation()">
            @if ($canAddTasksFromChecklist()) {
              <wb-button-icon class="add-child" size="Small" displayStyle="Tertiary" iconLeft="fa-regular fa-list-check" [tooltip]="addTasksFromChecklistTooltip(row)" (onClick)="addTasksFromChecklist($event, row)" />
            }
            <wb-button-icon class="add-child" size="Small" displayStyle="Tertiary" iconLeft="fa-regular fa-plus" [tooltip]="addChildTooltip(row)" (onClick)="addChild($event, row)" />
          </div>
        }
        @if (row.badges?.length || $noCrew()) {
          <div class="properties badges">
            @for (badge of row.badges; track badge.id) {
              <w-badge [mode]="badge.mode ?? BadgeMode.Pill" [label]="badge.label" [tooltip]="badge.tooltip" [iconLeft]="badge.iconLeft" color="var(--local-outline-row-property-text)" backgroundColor="var(--local-outline-row-property-bg)" borderColor="var(--local-outline-row-property-border)" size="xs" />
            }
            @if ($noCrew()) {
              <w-badge class="no-crew" [mode]="BadgeMode.Pill" label="No crew" tooltip="No default crew or contractor" iconLeft="fa-solid fa-user-slash" color="var(--local-outline-row-warning-text)" backgroundColor="var(--local-outline-row-warning-bg)" borderColor="var(--local-outline-row-warning-border)" size="xs" />
            }
          </div>
        }
        @if ($properties().length) {
          <div class="properties">
            @for (property of $properties(); track property.id) {
              @if (property.card) {
                <w-badge [mode]="BadgeMode.Pill" [label]="property.label" [pTooltip]="scheduleTip" [autoHide]="false" tooltipPosition="top" tooltipStyleClass="wb-dark-tooltip" appendTo="body" [iconLeft]="property.iconLeft" [iconLeftColor]="property.iconLeftColor" color="var(--local-outline-row-property-text)" backgroundColor="var(--local-outline-row-property-bg)" borderColor="var(--local-outline-row-property-border)" size="xs" />
              } @else {
                <w-badge [mode]="BadgeMode.Pill" [label]="property.label" [tooltip]="property.tooltip" [iconLeft]="property.iconLeft" [iconLeftColor]="property.iconLeftColor" color="var(--local-outline-row-property-text)" backgroundColor="var(--local-outline-row-property-bg)" borderColor="var(--local-outline-row-property-border)" size="xs" />
              }
            }
          </div>
        }
        <ng-template #scheduleTip>
          @if ($scheduleCard(); as card) {
            <div class="outline-schedule-card">
              <div class="card-row">
                <div class="card-label">Schedule</div>
                <div class="card-value">{{ card.schedule }}</div>
              </div>
              @if (card.firstDue) {
                <div class="card-row">
                  <div class="card-label">First due</div>
                  <div class="card-value">{{ card.firstDue }}</div>
                </div>
              }
              @if (card.next) {
                <div class="card-row">
                  <div class="card-label">Next</div>
                  <div class="card-value">{{ card.next }}</div>
                </div>
              }
            </div>
          }
        </ng-template>
        @if ($crew(); as crew) {
          <span class="crew" [wbContent]="crew"></span>
        }
      </div>
    </div>
}
